import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { UserInfoGuard } from 'src/app/core/guards/user-info.guard';
import { NftCollectionsComponent } from './nft-collections/nft-collections.component'
import { NftProductOverviewComponent } from './nft-product-overview/nft-product-overview.component';
import { NftProductsComponent } from './nft-products/nft-products.component';
import { NftProfileComponent } from './nft-profile/nft-profile.component';

import { NftComponent } from './nft.component';

const routes: Routes = [{

  path: '',
  component: NftComponent,
  children: [
    {
      path: 'collections',
      component: NftCollectionsComponent,
    },
    {
      path: 'collections/products/:id',
      component: NftProductsComponent,
    },
    {
      path: 'product/overview/:id',
      component: NftProductOverviewComponent,
    },
    
  ],

},


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NftRoutingModule {


}
